var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_403_34353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7206 15.7801C15.0133 16.0728 15.4878 16.0728 15.7805 15.7801C16.0731 15.4875 16.0731 15.013 15.7805 14.7203L13.06 12L15.7805 9.27966C16.0732 8.987 16.0732 8.51252 15.7805 8.21987C15.4878 7.92721 15.0133 7.92721 14.7207 8.21987L12.0002 10.9402L9.27934 8.21949C8.98667 7.92684 8.51217 7.92684 8.2195 8.21949C7.92683 8.51214 7.92683 8.98663 8.2195 9.27928L10.9404 12L8.21954 14.7207C7.92687 15.0134 7.92687 15.4879 8.21954 15.7805C8.5122 16.0732 8.98671 16.0732 9.27937 15.7805L12.0002 13.0598L14.7206 15.7801Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_403_34353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossNew);
export default __webpack_public_path__ + "static/media/cross-new.89f84e1c05d0fa6e93fd0147f51300bc.svg";
export { ForwardRef as ReactComponent };